import React, { useEffect, useState } from 'react'
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import { Save, Visibility, VisibilityOff } from '@mui/icons-material'
import { extractApiError, siteSettingsService } from '../services/api'

export default function SiteSettingsPage() {
  const [password, setPassword] = useState('')
  const [show, setShow] = useState(false)
  const [updatedAt, setUpdatedAt] = useState<string | null>(null)
  const [updatedBy, setUpdatedBy] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')

  const load = async () => {
    setLoading(true)
    setError('')
    try {
      const res = await siteSettingsService.get()
      const data = res?.data ?? res
      setPassword(data?.defaultDbPassword ?? '')
      setUpdatedAt(data?.updatedAt ?? null)
      setUpdatedBy(data?.updatedByName ?? null)
    } catch (e) {
      setError(extractApiError(e, 'تعذر جلب الإعدادات'))
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    load()
  }, [])

  const save = async () => {
    setSaving(true)
    setError('')
    setSuccess('')
    try {
      const res = await siteSettingsService.update(password)
      const data = res?.data ?? res
      setPassword(data?.defaultDbPassword ?? password)
      setUpdatedAt(data?.updatedAt ?? null)
      setUpdatedBy(data?.updatedByName ?? null)
      setSuccess('تم حفظ باسوورد الداتابيس الافتراضي')
    } catch (e) {
      setError(extractApiError(e, 'تعذر الحفظ'))
    } finally {
      setSaving(false)
    }
  }

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" py={8}>
        <CircularProgress />
      </Box>
    )
  }

  return (
    <Box>
      <Typography variant="h5" fontWeight={700} mb={1}>
        إعدادات الموقع
      </Typography>
      <Typography color="text.secondary" mb={3}>
        باسوورد PostgreSQL الافتراضي الذي يُسلَّم عند تفعيل MeraSystemApi بكود API
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>
          {error}
        </Alert>
      )}
      {success && (
        <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSuccess('')}>
          {success}
        </Alert>
      )}

      <Card>
        <CardContent>
          <Stack spacing={2} maxWidth={480}>
            <TextField
              label="باسوورد الداتابيس الافتراضي"
              type={show ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              fullWidth
              InputProps={{
                endAdornment: (
                  <Button size="small" onClick={() => setShow((v) => !v)}>
                    {show ? <VisibilityOff /> : <Visibility />}
                  </Button>
                ),
              }}
            />
            {(updatedAt || updatedBy) && (
              <Typography variant="body2" color="text.secondary">
                آخر تعديل{updatedBy ? ` بواسطة ${updatedBy}` : ''}
                {updatedAt ? ` — ${new Date(updatedAt).toLocaleString('ar')}` : ''}
              </Typography>
            )}
            <Button
              variant="contained"
              startIcon={saving ? <CircularProgress size={18} color="inherit" /> : <Save />}
              disabled={saving || !password.trim()}
              onClick={save}
            >
              حفظ
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  )
}
